<template>
    <div>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <rsa-scheda-relazione-sanitaria-fonte-dei-dati-edit-component :jsonDataFonteDati="jsonData.fonteDeiDati" @update="onUpdateRelazioneSanitariaFonteDati" :isReadOnly="isReadOnly" :id-accettazione="idAccettazione" ref="cmpFonteDeiDati" />
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <rsa-scheda-relazione-sanitaria-anamnesi-familiare-edit-component :jsonDataAnamnesiFamiliare="jsonData.anamnesiFamiliare" @update="onUpdateRelazioneSanitariaAnamnesiFamiliare" :isReadOnly="isReadOnly" :id-accettazione="idAccettazione" ref="cmpAnamnesiFamiliare" />
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <rsa-scheda-relazione-sanitaria-anamnesi-fisiologica-edit-component :jsonDataAnamnesiFisiologica="jsonData.anamnesiFisiologica" @update="onUpdateRelazioneSanitariaAnamnesiFisiologica" :isReadOnly="isReadOnly" :id-accettazione="idAccettazione" ref="cmpAnamnesiFisiologica" />
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <rsa-scheda-relazione-sanitaria-anamnesi-personologica-edit-component :jsonDataAnamnesiPersonologica="jsonData.anamnesiPersonologica" @update="onUpdateRelazioneSanitariaAnamnesiPersonologica" :isReadOnly="isReadOnly" :id-accettazione="idAccettazione" ref="cmpAnamnesiPersonologica" />
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <rsa-scheda-relazione-sanitaria-anamnesi-patologica-edit-component :jsonDataAnamnesiPatologica="jsonData.anamnesiPatologica" @update="onUpdateRelazioneSanitariaAnamnesiPatologica" :isReadOnly="isReadOnly" :id-accettazione="idAccettazione" ref="cmpAnamnesiPatologica" />
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <rsa-scheda-relazione-sanitaria-anamnesi-psichiatrica-remota-edit-component :jsonDataAnamnesiPsichiatricaRemota="jsonData.anamnesiPsichiatricaRemota" @update="onUpdateRelazioneSanitariaAnamnesiPsichiatricaRemota" :isReadOnly="isReadOnly" :id-accettazione="idAccettazione" ref="cmpAnamnesiPsichiatricaRemota" />
            </b-col>
        </b-row>

        <b-row>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <rsa-scheda-relazione-sanitaria-anamnesi-psichiatrica-prossima-edit-component :jsonDataAnamnesiPsichiatricaProssima="jsonData.anamnesiPsichiatricaProssima" @update="onUpdateRelazioneSanitariaAnamnesiPsichiatricaProssima" :isReadOnly="isReadOnly" :id-accettazione="idAccettazione" ref="cmpAnamnesiPsichiatricaProssima" />
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <rsa-scheda-relazione-sanitaria-anamnesi-farmacologica-edit-component :jsonDataAnamnesiFarmacologica="jsonData.anamnesiFarmacologica" @update="onUpdateRelazioneSanitariaAnamnesiFarmacologica" :isReadOnly="isReadOnly" :id-accettazione="idAccettazione" ref="cmpAnamnesiFarmacologica" />
            </b-col>
        </b-row>

        <b-row>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <rsa-scheda-relazione-sanitaria-assetto-psicopatologico-ingresso-edit-component :jsonDataAssettoPsicopatologicoIngresso="jsonData.assettoPsicopatologicoIngresso" @update="onUpdateRelazioneSanitariaAssettoPsicopatologicoIngresso" :isReadOnly="isReadOnly" :id-accettazione="idAccettazione" ref="cmpAssettoPsicopatologicoIngresso" />
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <rsa-scheda-relazione-sanitaria-esame-obiettivo-gen-loc-edit-component :jsonDataEsameObiettivoGenLoc="jsonData.esameObiettivoGenLocale" @update="onUpdateRelazioneSanitariaEsameObiettivoGenLoc" :isReadOnly="isReadOnly" :id-accettazione="idAccettazione" ref="cmpEsameObiettivoGenLoc" />
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <rsa-scheda-relazione-sanitaria-costituzione-edit-component :jsonDataCostituzione="jsonData.costituzione" @update="onUpdateRelazioneSanitariaCostituzione" :isReadOnly="isReadOnly" :id-accettazione="idAccettazione" ref="cmpCostituzione" />
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <rsa-scheda-relazione-sanitaria-apparato-locomotore-edit-component :jsonDataApparatoLocomotore="jsonData.apparatoLocomotore" @update="onUpdateRelazioneSanitariaApparatoLocomotore" :isReadOnly="isReadOnly" :id-accettazione="idAccettazione" ref="cmpApparatoLocomotore" />
            </b-col>
        </b-row>

        <b-row>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <rsa-scheda-relazione-sanitaria-apparato-muscolare-edit-component :jsonDataApparatoMuscolare="jsonData.apparatoMuscolare" @update="onUpdateRelazioneSanitariaApparatoMuscolare" :isReadOnly="isReadOnly" :id-accettazione="idAccettazione" ref="cmpApparatoMuscolare" />
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <rsa-scheda-relazione-sanitaria-apparato-respiratorio-edit-component :jsonDataApparatoRespiratorio="jsonData.apparatoRespiratorio" @update="onUpdateRelazioneSanitariaApparatoRespiratorio" :isReadOnly="isReadOnly" :id-accettazione="idAccettazione" ref="cmpApparatoRespiratorio" />
            </b-col>
        </b-row>

        <b-row>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <rsa-scheda-relazione-sanitaria-apparato-cardiocircolatorio-edit-component :jsonDataApparatoCardioCircolatorio="jsonData.apparatoCardioCircolatorio" @update="onUpdateRelazioneSanitariaApparatoCardioCircolatorio" :isReadOnly="isReadOnly" :id-accettazione="idAccettazione" ref="cmpApparatoCardioCircolatorio" />
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <rsa-scheda-relazione-sanitaria-apparato-gastroenterico-edit-component :jsonDataApparatoGastroenterico="jsonData.apparatoGastroenterico" @update="onUpdateRelazioneSanitariaApparatoGastroenterico" :isReadOnly="isReadOnly" :id-accettazione="idAccettazione" ref="cmpApparatoGastroenterico" />
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <rsa-scheda-relazione-sanitaria-apparato-urogenitale-edit-component :jsonDataApparatoUrogenitale="jsonData.apparatoUrogenitale" @update="onUpdateRelazioneSanitariaApparatoUrogenitale" :isReadOnly="isReadOnly" :id-accettazione="idAccettazione" ref="cmpApparatoUrogenitale" />
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <rsa-scheda-relazione-sanitaria-organi-senso-edit-component :jsonDataOrganiSenso="jsonData.organiSenso" @update="onUpdateRelazioneSanitariaOrganiSenso" :isReadOnly="isReadOnly" :id-accettazione="idAccettazione" ref="cmpOrganiSenso" />
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <rsa-scheda-relazione-sanitaria-esame-neurologico-ingresso-edit-component :jsonDataEsameNeurologicoIngresso="jsonData.esameNeurologicoIngresso" @update="onUpdateRelazioneSanitariaEsameNeurologicoIngresso" :isReadOnly="isReadOnly" :id-accettazione="idAccettazione" ref="cmpEsameNeurologicoIngresso" />
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <rsa-scheda-relazione-sanitaria-anamnesi-psicologica-edit-component :jsonDataAnamnesiPsicologica="jsonData.anamnesiPsicologica" @update="onUpdateRelazioneSanitariaAnamnesiPsicologica" :isReadOnly="isReadOnly" :id-accettazione="idAccettazione" ref="cmpAnamnesiPsicologica" />
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <rsa-scheda-relazione-sanitaria-anamnesi-pedagogica-edit-component :jsonDataAnamnesiPedagogica="jsonData.anamnesiPedagogica" @update="onUpdateRelazioneSanitariaAnamnesiPedagogica" :isReadOnly="isReadOnly" :id-accettazione="idAccettazione" ref="cmpAnamnesiPedagogica" />
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <rsa-scheda-relazione-sanitaria-anamnesi-sociale-edit-component :jsonDataAnamnesiSociale="jsonData.anamnesiSociale" @update="onUpdateRelazioneSanitariaAnamnesiSociale" :isReadOnly="isReadOnly" :id-accettazione="idAccettazione" ref="cmpAnamnesiSociale" />
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <rsa-scheda-relazione-sanitaria-situazione-generale-edit-component :jsonDataSituazioneGenerale="jsonData.situazioneGenerale" @update="onUpdateRelazioneSanitariaSituazioneGenerale" :isReadOnly="isReadOnly" :id-accettazione="idAccettazione" ref="cmpSituazioneGenerale" />
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <rsa-scheda-relazione-sanitaria-situazione-medica-edit-component :jsonDataSituazioneMedica="jsonData.situazioneMedica" @update="onUpdateRelazioneSanitariaSituazioneMedica" :isReadOnly="isReadOnly" :id-accettazione="idAccettazione" ref="cmpSituazioneMedica" />
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <rsa-scheda-relazione-sanitaria-scuola-lavoro-edit-component :jsonDataScuolaLavoro="jsonData.scuolaLavoro" @update="onUpdateRelazioneSanitariaScuolaLavoro" :isReadOnly="isReadOnly" :id-accettazione="idAccettazione" ref="cmpScuolaLavoro" />
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <rsa-scheda-relazione-sanitaria-invalidita-civile-edit-component :jsonDataInvaliditaCivile="jsonData.invaliditaCivile" @update="onUpdateRelazioneSanitariaInvaliditaCivile" :isReadOnly="isReadOnly" :id-accettazione="idAccettazione" ref="cmpEsameInvaliditaCivile" />
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <rsa-scheda-relazione-sanitaria-situazione-economica-edit-component :jsonDataSituazioneEconomica="jsonData.situazioneEconomica" @update="onUpdateRelazioneSanitariaSituazioneEconomica" :isReadOnly="isReadOnly" :id-accettazione="idAccettazione" ref="cmpSituazioneEconomica" />
            </b-col>
        </b-row>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import RsaSchedaRelazioneSanitariaAnamnesiFamiliareEditComponent from "./RsaSchedaRelazioneSanitariaAnamnesiFamiliareEditComponent.vue";
import RsaSchedaRelazioneSanitariaAnamnesiFarmacologicaEditComponent from "./RsaSchedaRelazioneSanitariaAnamnesiFarmacologicaEditComponent.vue";
import RsaSchedaRelazioneSanitariaAnamnesiFisiologicaEditComponent from "./RsaSchedaRelazioneSanitariaAnamnesiFisiologicaEditComponent.vue";
import RsaSchedaRelazioneSanitariaAnamnesiPatologicaEditComponent from "./RsaSchedaRelazioneSanitariaAnamnesiPatologicaEditComponent.vue";
import RsaSchedaRelazioneSanitariaAnamnesiPedagogicaEditComponent from "./RsaSchedaRelazioneSanitariaAnamnesiPedagogicaEditComponent.vue";
import RsaSchedaRelazioneSanitariaAnamnesiPersonologicaEditComponent from "./RsaSchedaRelazioneSanitariaAnamnesiPersonologicaEditComponent.vue";
import RsaSchedaRelazioneSanitariaAnamnesiPsichiatricaProssimaEditComponent from "./RsaSchedaRelazioneSanitariaAnamnesiPsichiatricaProssimaEditComponent.vue";
import RsaSchedaRelazioneSanitariaAnamnesiPsichiatricaRemotaEditComponent from "./RsaSchedaRelazioneSanitariaAnamnesiPsichiatricaRemotaEditComponent.vue";
import RsaSchedaRelazioneSanitariaAnamnesiPsicologicaEditComponent from "./RsaSchedaRelazioneSanitariaAnamnesiPsicologicaEditComponent.vue";
import RsaSchedaRelazioneSanitariaAnamnesiSocialeEditComponent from "./RsaSchedaRelazioneSanitariaAnamnesiSocialeEditComponent.vue";
import RsaSchedaRelazioneSanitariaApparatoCardiocircolatorioEditComponent from "./RsaSchedaRelazioneSanitariaApparatoCardiocircolatorioEditComponent.vue";
import RsaSchedaRelazioneSanitariaApparatoGastroentericoEditComponent from "./RsaSchedaRelazioneSanitariaApparatoGastroentericoEditComponent.vue";
import RsaSchedaRelazioneSanitariaApparatoLocomotoreEditComponent from "./RsaSchedaRelazioneSanitariaApparatoLocomotoreEditComponent.vue";
import RsaSchedaRelazioneSanitariaApparatoMuscolareEditComponent from "./RsaSchedaRelazioneSanitariaApparatoMuscolareEditComponent.vue";
import RsaSchedaRelazioneSanitariaApparatoRespiratorioEditComponent from "./RsaSchedaRelazioneSanitariaApparatoRespiratorioEditComponent.vue";
import RsaSchedaRelazioneSanitariaApparatoUrogenitaleEditComponent from "./RsaSchedaRelazioneSanitariaApparatoUrogenitaleEditComponent.vue";
import RsaSchedaRelazioneSanitariaAssettoPsicopatologicoIngressoEditComponent from "./RsaSchedaRelazioneSanitariaAssettoPsicopatologicoIngressoEditComponent.vue";
import RsaSchedaRelazioneSanitariaCostituzioneEditComponent from "./RsaSchedaRelazioneSanitariaCostituzioneEditComponent.vue";
import RsaSchedaRelazioneSanitariaEsameNeurologicoIngressoEditComponent from "./RsaSchedaRelazioneSanitariaEsameNeurologicoIngressoEditComponent.vue";
import RsaSchedaRelazioneSanitariaEsameObiettivoGenLocEditComponent from "./RsaSchedaRelazioneSanitariaEsameObiettivoGenLocEditComponent.vue";
import RsaSchedaRelazioneSanitariaFonteDeiDatiEditComponent from "./RsaSchedaRelazioneSanitariaFonteDeiDatiEditComponent.vue";
import RsaSchedaRelazioneSanitariaInvaliditaCivileEditComponent from "./RsaSchedaRelazioneSanitariaInvaliditaCivileEditComponent.vue";
import RsaSchedaRelazioneSanitariaOrganiSensoEditComponent from "./RsaSchedaRelazioneSanitariaOrganiSensoEditComponent.vue";
import RsaSchedaRelazioneSanitariaScuolaLavoroEditComponent from "./RsaSchedaRelazioneSanitariaScuolaLavoroEditComponent.vue";
import RsaSchedaRelazioneSanitariaSituazioneEconomicaEditComponent from "./RsaSchedaRelazioneSanitariaSituazioneEconomicaEditComponent.vue";
import RsaSchedaRelazioneSanitariaSituazioneGeneraleEditComponent from "./RsaSchedaRelazioneSanitariaSituazioneGeneraleEditComponent.vue";
import RsaSchedaRelazioneSanitariaSituazioneMedicaEditComponent from "./RsaSchedaRelazioneSanitariaSituazioneMedicaEditComponent.vue";

export default {
    mixins: [UtilityMixin],
    components: {
        RsaSchedaRelazioneSanitariaAnamnesiFamiliareEditComponent,
        RsaSchedaRelazioneSanitariaAnamnesiFarmacologicaEditComponent,
        RsaSchedaRelazioneSanitariaAnamnesiFisiologicaEditComponent,
        RsaSchedaRelazioneSanitariaAnamnesiPatologicaEditComponent,
        RsaSchedaRelazioneSanitariaAnamnesiPedagogicaEditComponent,
        RsaSchedaRelazioneSanitariaAnamnesiPersonologicaEditComponent,
        RsaSchedaRelazioneSanitariaAnamnesiPsichiatricaProssimaEditComponent,
        RsaSchedaRelazioneSanitariaAnamnesiPsichiatricaRemotaEditComponent,
        RsaSchedaRelazioneSanitariaAnamnesiPsicologicaEditComponent,
        RsaSchedaRelazioneSanitariaAnamnesiSocialeEditComponent,
        RsaSchedaRelazioneSanitariaApparatoCardiocircolatorioEditComponent,
        RsaSchedaRelazioneSanitariaApparatoGastroentericoEditComponent,
        RsaSchedaRelazioneSanitariaApparatoLocomotoreEditComponent,
        RsaSchedaRelazioneSanitariaApparatoMuscolareEditComponent,
        RsaSchedaRelazioneSanitariaApparatoRespiratorioEditComponent,
        RsaSchedaRelazioneSanitariaApparatoUrogenitaleEditComponent,
        RsaSchedaRelazioneSanitariaAssettoPsicopatologicoIngressoEditComponent,
        RsaSchedaRelazioneSanitariaCostituzioneEditComponent,
        RsaSchedaRelazioneSanitariaEsameNeurologicoIngressoEditComponent,
        RsaSchedaRelazioneSanitariaEsameObiettivoGenLocEditComponent,
        RsaSchedaRelazioneSanitariaFonteDeiDatiEditComponent,
        RsaSchedaRelazioneSanitariaInvaliditaCivileEditComponent,
        RsaSchedaRelazioneSanitariaOrganiSensoEditComponent,
        RsaSchedaRelazioneSanitariaScuolaLavoroEditComponent,
        RsaSchedaRelazioneSanitariaSituazioneEconomicaEditComponent,
        RsaSchedaRelazioneSanitariaSituazioneGeneraleEditComponent,
        RsaSchedaRelazioneSanitariaSituazioneMedicaEditComponent,
    },
    props: {
        idRisorsa: {
            type: String,
            default: function () {
                return null;
            },
        },
        idAccettazione: {
            type: String,
            default: function () {
                return null;
            },
        },
        isReadOnly: {
            type: Boolean,
        },
    },
    data() {
        return {
            pathResourceSchedaRelazioneSanitaria: "/rsaschedarelazionesanitariatestata",
            jsonData: {
                id: null,
                idAccettazione: this.idAccettazione,
                anamnesiFamiliare: {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    voce: "",
                },
                anamnesiFisiologica: {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    voce: "",
                },

                anamnesiPatologica: {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    voce: "",
                },

                anamnesiPedagogica: {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    voce: "",
                },

                anamnesiPersonologica: {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    voce: "",
                },

                anamnesiPsichiatricaProssima: {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    voce: "",
                },

                anamnesiPsichiatricaRemota: {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    voce: "",
                },

                anamnesiPsicologica: {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    voce: "",
                },

                anamnesiSociale: {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    voce: "",
                },

                apparatoCardioCircolatorio: {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    toniCardiaci: "",
                    frequenzaCardiaca: "",
                    pressioneArteriosa: "",
                    polsiPeriferici: "",
                    edemiDecliviCianosi: "",
                },

                apparatoGastroenterico: {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    addome: "",
                    organiIpocondriaci: "",
                    alvo: "",
                },

                apparatoLocomotore: {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    atteggiamentiDecubito: "",
                    morfologiaSingoleParti: "",
                    sviluppoScheletro: "",
                },

                apparatoMuscolare: {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    masseMuscolari: "",
                },

                apparatoRespiratorio: {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    formaTorace: "",
                    espansibilitaPolmonareBilaterale: "",
                    fvt: "",
                    murmureVescicolari: "",
                },

                apparatoUrogenitale: {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    manovraGiordano: "",
                    puntiUretrali: "",
                    diuresi: "",
                },

                assettoPsicopatologicoIngresso: {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    voce: "",
                },

                costituzione: {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    peso: "",
                    altezza: "",
                    tipologia: "",
                    condizioniNutrSangue: "",
                    cuteMucoseVisibili: "",
                    linfoghiandole: "",
                    capo: "",
                    dentatura: "",
                    pannicoloAdiposo: "",
                },

                esameNeurologicoIngresso: {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    voce: "",
                },

                esameObiettivoGenLocale: {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    voce: "",
                },

                fonteDeiDati: {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    voce: "",
                },

                invaliditaCivile: {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    invalidita: "",
                    percentualeInvalidita: "",
                    indennitaAccompagnamento: "",
                    situazioneLegge: "",
                    legge: "",
                },

                organiSenso: {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    tatto: "",
                    gusto: "",
                    olfatto: "",
                    vista: "",
                    udito: "",
                },

                scuolaLavoro: {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    titoloStudio: "",
                    situazioneLavorativa: "",
                    noteSituazioneLavorativa: "",
                },

                situazioneEconomica: {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    fonteRisorseEconomiche: "",
                },

                situazioneGenerale: {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    colloquioAvvenutoCon: "",
                    cittadinanza: "",
                    statoCivile: "",
                    eventualeDomicilio: "",
                    familiareRiferimento: "",
                    posizioneGiuridica: "",
                    personaIncaricata: "",
                    provvedimentiPenali: "",
                    composizioneNucleoFamiliare: "",
                    situazioneAbitativa: "",
                },

                situazioneMedica: {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    medicoCurante: "",
                    esenzioneTicket: "",
                },
            },
        };
    },
    mounted() {
        let me = this;
        me.jsonData.idAccettazione = me.idAccettazione;
        if (me.idRisorsa !== null) {
            me.loadData();
        }
    },
    methods: {
        loadData() {
            let me = this;
            let path = process.env.VUE_APP_PATH_API + me.pathResourceSchedaRelazioneSanitaria + "/" + me.idRisorsa;
            UtilityMixin.methods.restCallGet(path, null, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.jsonData = response.data.data;
        },
        loadDataError(error) {
            let me = this;
            me.$emit("afterLoadData", error);
            me.$bvToast.toast("Errore durante il caricamento", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        onSalvaSchedaRelazioneSanitaria() {
            let me = this;
            me.jsonData.idAccettazione = me.idAccettazione;
            if (!me.jsonData.idAccettazione) {
                me.$bvToast.toast("Errore: ID Accettazione mancante", {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
                return;
            }     
            UtilityMixin.methods.saveResource(me.pathResourceSchedaRelazioneSanitaria, me.jsonData, me.saveSchedaRelazioneSanitariaSuccessResponse, me.saveSchedaRelazioneSanitariaErrorResponse);
        },
        saveSchedaRelazioneSanitariaSuccessResponse() {
            let me = this;
            me.$emit("afterSaveSuccess");

            me.$bvToast.toast("Salvataggio avvenuto con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },
        saveSchedaRelazioneSanitariaErrorResponse(response) {
            let me = this;
            if (response.response.status === 400) {
                me.$bvModal.msgBoxOk(response.response.data.messaggio, {
                    title: "ATTEZIONE",
                    size: "md",
                    okVariant: "outline-danger",
                    headerClass: "sa-msg-header-danger",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                });
            } else {
                me.$bvToast.toast("Errore nel salvataggio in edit component" + response.message, {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
            }
        },
        onUpdateRelazioneSanitariaAnamnesiFamiliare(data) {
            let me = this;
            me.jsonData.anamnesiFamiliare = data;
            me.$emit("update", me.jsonData);
        },
        onUpdateRelazioneSanitariaAnamnesiFarmacologica(data) {
            let me = this;
            me.jsonData.anamnesiFarmacologica = data;
            me.$emit("update", me.jsonData);
        },
        onUpdateRelazioneSanitariaAnamnesiFisiologica(data) {
            let me = this;
            me.jsonData.anamnesiFisiologica = data;
            me.$emit("update", me.jsonData);
        },
        onUpdateRelazioneSanitariaAnamnesiPatologica(data) {
            let me = this;
            me.jsonData.anamnesiPatologica = data;
            me.$emit("update", me.jsonData);
        },
        onUpdateRelazioneSanitariaAnamnesiPedagogica(data) {
            let me = this;
            me.jsonData.anamnesiPedagogica = data;
            me.$emit("update", me.jsonData);
        },

        onUpdateRelazioneSanitariaAnamnesiPersonologica(data) {
            let me = this;
            me.jsonData.anamnesiPersonologica = data;
            me.$emit("update", me.jsonData);
        },

        onUpdateRelazioneSanitariaAnamnesiPsichiatricaProssima(data) {
            let me = this;
            me.jsonData.anamnesiPsichiatricaProssima = data;
            me.$emit("update", me.jsonData);
        },

        onUpdateRelazioneSanitariaAnamnesiPsichiatricaRemota(data) {
            let me = this;
            me.jsonData.anamnesiPsichiatricaRemota = data;
            me.$emit("update", me.jsonData);
        },

        onUpdateRelazioneSanitariaAnamnesiPsicologica(data) {
            let me = this;
            me.jsonData.anamnesiPsicologica = data;
            me.$emit("update", me.jsonData);
        },

        onUpdateRelazioneSanitariaAnamnesiSociale(data) {
            let me = this;
            me.jsonData.anamnesiSociale = data;
            me.$emit("update", me.jsonData);
        },

        onUpdateRelazioneSanitariaApparatoCardioCircolatorio(data) {
            let me = this;
            me.jsonData.apparatoCardioCircolatorio = data;
            me.$emit("update", me.jsonData);
        },

        onUpdateRelazioneSanitariaApparatoGastroenterico(data) {
            let me = this;
            me.jsonData.apparatoGastroenterico = data;
            me.$emit("update", me.jsonData);
        },

        onUpdateRelazioneSanitariaApparatoLocomotore(data) {
            let me = this;
            me.jsonData.apparatoLocomotore = data;
            me.$emit("update", me.jsonData);
        },

        onUpdateRelazioneSanitariaApparatoMuscolare(data) {
            let me = this;
            me.jsonData.apparatoMuscolare = data;
            me.$emit("update", me.jsonData);
        },

        onUpdateRelazioneSanitariaApparatoRespiratorio(data) {
            let me = this;
            me.jsonData.apparatoRespiratorio = data;
            me.$emit("update", me.jsonData);
        },

        onUpdateRelazioneSanitariaApparatoUrogenitale(data) {
            let me = this;
            me.jsonData.apparatoUrogenitale = data;
            me.$emit("update", me.jsonData);
        },

        onUpdateRelazioneSanitariaAssettoPsicopatologicoIngresso(data) {
            let me = this;
            me.jsonData.assettoPsicopatologicoIngresso = data;
            me.$emit("update", me.jsonData);
        },

        onUpdateRelazioneSanitariaCostituzione(data) {
            let me = this;
            me.jsonData.costituzione = data;
            me.$emit("update", me.jsonData);
        },

        onUpdateRelazioneSanitariaEsameNeurologicoIngresso(data) {
            let me = this;
            me.jsonData.esameNeurologicoIngresso = data;
            me.$emit("update", me.jsonData);
        },

        onUpdateRelazioneSanitariaEsameObiettivoGenLoc(data) {
            let me = this;
            me.jsonData.esameObiettivoGenLocale = data;
            me.$emit("update", me.jsonData);
        },

        onUpdateRelazioneSanitariaFonteDati(data) {
            let me = this;
            me.jsonData.fonteDeiDati = data;
            me.$emit("update", me.jsonData);
        },

        onUpdateRelazioneSanitariaInvaliditaCivile(data) {
            let me = this;
            me.jsonData.invaliditaCivile = data;
            me.$emit("update", me.jsonData);
        },

        onUpdateRelazioneSanitariaOrganiSenso(data) {
            let me = this;
            me.jsonData.organiSenso = data;
            me.$emit("update", me.jsonData);
        },

        onUpdateRelazioneSanitariaScuolaLavoro(data) {
            let me = this;
            me.jsonData.scuolaLavoro = data;
            me.$emit("update", me.jsonData);
        },

        onUpdateRelazioneSanitariaSituazioneEconomica(data) {
            let me = this;
            me.jsonData.situazioneEconomica = data;
            me.$emit("update", me.jsonData);
        },

        onUpdateRelazioneSanitariaSituazioneGenerale(data) {
            let me = this;
            me.jsonData.situazioneGenerale = data;
            me.$emit("update", me.jsonData);
        },

        onUpdateRelazioneSanitariaSituazioneMedica(data) {
            let me = this;
            me.jsonData.situazioneMedica = data;
            me.$emit("update", me.jsonData);
        },
    },
};
</script>
